
/** Base permissions common to all roles */
export interface RolePermission {
  id: string;
  roleTitle: string;
  editTitle: boolean;
  editTemplateStructure: boolean;
  allocateGroupDeptOrg: boolean;
  addRemoveTags: boolean;
  changeOwner: boolean;
  inviteRemoveParticipant: boolean;
  inviteRemoveReader: boolean;
  inviteRemoveLeader: boolean;
  addEditDeleteComments: boolean;
  /** Control Panel `EditKPILinks` / JSON `editKPILinks` — KPI links & progress notes on linked key results. */
  editKPILinks?: boolean;
}

/** Permissions for the “Evaluate” area */
export interface EvaluateRolePermission extends RolePermission {
  viewQuestionnaire: boolean;
  viewGeneratedContent: boolean;
  editQuestionnaireContent: boolean;
  editGeneratedContent: boolean;
  editQuestionGrade: boolean;
  editOverallGrade: boolean;
  generateAssessment: boolean;
  editDate: boolean;
  editScope: boolean;
  archiveDiagnostic: boolean;
  exportDiagnostic: boolean;
  canEditNotesPermissions: boolean;
}

/** Permissions for the “Develop” area – extends base RolePermission */
export interface DevelopRolePermission extends RolePermission {
  addEditDeleteLearnerComments?: boolean;
  addEditDeleteLineManagerComments?: boolean;
  addEditDeleteMentorComments?: boolean;
  addEditDeleteReflectionsComments?: boolean;
  editCompletionDate?: boolean;
  editDueDate?: boolean;
  canEditNotesPermissions?: boolean;
  [key: string]: unknown; // Allow other Develop-specific fields from API
}


export interface EnquireRolePermission extends EvaluateRolePermission {

}


export interface ImproveRolePermission extends RolePermission {
  editActualImpact: boolean;
}

export enum ClientRolePermissionType {
  SuperAdmin = 0,
  AdvancedAdmin = 1,
  ClientAdmin = 2,
  ClientOwner = 3,
  MesmaAdmin = 4,
  StandardUser = 5,
  DepartmentOwner = 6,
  PartnerOwner = 7,
}

export interface ClientRolePermission {
  id: string;
  roleTitle: string;
  permissionType: ClientRolePermissionType;
  importTemplate: boolean;
  deleteTemplate: boolean;
  allocateGroupDeptOrg: boolean;
  accessAllClientSubsets: boolean;
  addEditRemoveTemplates: boolean;
  accessDevelop: boolean;
  mandateTemplates: boolean;
  mandatePartnerTemplates: boolean;
  mandateDepartmentTemplates: boolean;
  viewAllAreas: boolean;
  previewAllAreas: boolean;
}